<template>
    <div v-if="!isLoading" class="box box-primary" style="padding-bottom:10px;">
        <div class="box-header with-border">
            <h3 class="box-title">{{ translate('Order Summary') }}</h3>
        </div>
        <flashMessage />
        <div class="box-body">
            <div class="row">
                <div class="col-xs-12 table-responsive">
                    <table class="table table-striped ">
                        <thead>
                            <tr>
                                <th>{{ translate('Product') }}</th>
                                <th>{{ translate('Serial #') }}</th>
                                <th>{{ translate('Description') }}</th>
                                <th>{{ translate('Qty') }}</th>
                                <th>{{ translate('Subtotal') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td id="product_name">{{ product.Name }}</td>
                                <td id="product_sku">{{ product.SKU }}</td>
                                <td>
                                    {{ translate("x Topup amount can be used for WhatsApp Messaging Service or any other service in future") }} <br />
                                    {{ translate("x No expiry date for amount topped up") }}<br/>
                                    
                                    <div id="original_qty" v-show="!isChangingQty">
                                        x <span id="product_qty"></span> <span name="product_cat">{{ product.Cat.toLowerCase() }} &nbsp;&nbsp;</span>
                                        <a id="changeQty" style="cursor: pointer;" @click="toggleChangeQty">
                                            <i class="fa fa-pencil" style="color:lightcoral;" title="Edit"></i>
                                            {{ translate('Change Quantity') }}
                                        </a><br />
                                    </div>
                                    
                                    <!-- Changing Quantity Section -->
                                    <transition name="expand-from-button">
                                        <div id="changing_qty" v-if="isChangingQty" class="changing-qty" style="background-color:white;padding:10px;">
                                            <div class="form-group" style="margin-bottom:15px;">
                                                <label for="smsVolume" style="font-weight:600">
                                                    {{ translate('Select') }} <span name="product_cat_capital">{{ product.Cat.toLowerCase() }}</span>
                                                    {{ translate('Volume') }}
                                                </label>
                                                <div>
                                                    <div class="col-md-11" style="padding-left:0px;">
                                                        <input 
                                                            type="number" 
                                                            class="form-control" 
                                                            id="smsVolume" 
                                                            placeholder="Enter Quantity" 
                                                            :value="currentQuantity" 
                                                            @input="updateSlider($event.target.value)" 
                                                            max="50000000"
                                                            style="margin-bottom:5px;" 
                                                            oninput="this.value = this.value.replace(/^0+|[^0-9]+/g, '')"
                                                        >
                                                    </div>
                                                    <div class="col-md-1" style="padding:5px 0px 0px 0px;">
                                                        <span name="product_cat_capital">{{ product.Cat.toLowerCase() }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <br />
                                            <input 
                                                id="qtySlider" 
                                                type="text" 
                                                class="slider form-control" 
                                                value=""
                                                data-slider-min="0" 
                                                data-slider-max="500000" 
                                                data-slider-step="1000" 
                                                :data-slider-value="currentQuantity" 
                                                data-slider-orientation="horizontal" 
                                                data-slider-selection="before" 
                                                data-slider-tooltip="show" 
                                                data-slider-id="blue"
                                            >
                                            <br />
                                            <span class="invalid-feedback" role="alert" id="qty_alert"></span>
                                            <br />
                                            <button type="submit" class="btn btn-primary" 
                                             style="margin-right:5px;" 
                                             @click="updateProductFromChangingQty">
                                                {{ translate('Update') }}
                                            </button>
                                            <a id="cancelChangeQty" class="btn btn-danger" @click="cancelChangeQty">
                                                {{ translate('Cancel') }}
                                            </a>
                                        </div>
                                    </transition>
                                    x <span name="currency_code">{{ currency.code }}</span> <span id="product_unit_price">{{ formattedUnitPrice }}</span>/<span name="product_cat">{{ product.Cat.toLowerCase() }}</span>
                                    <br />
                                </td>
                                <td>1</td>
                                <td>
                                    <span name="currency_code">{{ currency.code }}</span> <span name="product_price"></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row">
                <!-- PaymentMethod Component -->
                <div class="col-md-6">
                    <PaymentMethod 
                    :paymentMethods="paymentMethods" 
                    :canPayDuitNow="canPayDuitNow" 
                    @method-selected="handleMethodSelected" 
                    />
                </div>
                <!-- start Amount Due Section(updateProductFromChangingTotal)-->
                <div class="col-md-6">
                    <p class="lead" style="font-weight: 600;">{{ translate('Amount Due') }} {{ getCurrentDate() }}</p>
                    <div class="table-responsive">
                        <table class="table">
                            <tbody>
                                <tr>
                                    <th style="width:50%">{{ translate('Subtotal') }}:</th>
                                    <td>
                                        <span name="currency_code">{{ currency.code }}</span> <span name="product_price" id="product_price"></span>
                                    </td>
                                </tr>
                                <tr id="tax_info_section" v-show="showTaxInfo">
                                    <th><span id="tax_setting"></span> {{ translate('Tax (SST)') }}</th>
                                    <td><span name="currency_code">{{ currency.code }}</span> <span id="product_tax" name="product_tax"></span></td>
                                </tr>
                                <tr>
                                    <th>{{ translate('Total') }}:</th>
                                    <td id="changeAmountTD">
                                        <div v-show="!isChangingAmount" id="original_total">
                                            <span name="currency_code">{{ currency.code }}</span> <span id="total_price">{{ product.total }}</span> <br />
                                            <a id="changeAmount" style="cursor: pointer;" @click="toggleChangeAmount">
                                                <i class="fa fa-pencil" style="color:lightcoral;" title="Edit"></i> {{ translate('Change Amount') }}
                                            </a>
                                        </div>
    
                                        <div v-show="isChangingAmount" id="changing_total">
                                            <div class="form-group" style="margin-bottom:15px;">
                                                <label for="topupAmount" style="font-weight:600">{{ translate('Enter Topup Amount') }}</label>
                                                <div>
                                                    <div class="col-md-2" style="padding:5px 0px 0px 0px;">
                                                        <span name="currency_code">{{ currency.code }}</span>
                                                    </div>
                                                    <div class="col-md-10" style="padding-left:0px;">
                                                        <input type="number" class="form-control" id="topupAmount" placeholder="Enter topup amount" value="" v-model="topupAmount" @input="handleInput"
                                                        @keyup.enter="updateProductFromChangingTotal" style="margin-bottom:5px;"> 
                                                        <span class="invalid-feedback" role="alert" id="topupAmount_alert">{{ alertMessage }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <button type="submit" class="btn btn-primary" @click="updateProductFromChangingTotal" id="updateProductFromChangingTotal" style="margin-right:5px;">
                                                {{ translate('Update') }}
                                            </button>
                                            <a @click="cancelChangeAmount" id="cancelChangeAmount" class="btn btn-danger">{{ translate('Cancel') }}</a>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p class="help-block">
                        <small>
                            <b>{{ translate('Note') }}</b><br />
                            - {{ translate('All Malaysian entities are subject to 6% SST.') }}<br />
                            <b>{{ translate('Refund Policy') }}</b><br />
                            - <span v-html="testOurServiceMessage"></span><br />
                            <span v-if="topupCount <= 1">- <span  v-html="newCustomerMessage"></span><br /></span>
                            - <span v-html="refundMessage"></span><br />
                        </small>
                    </p>
                </div>
                <!-- end Amount Due Section -->
            </div>

            <!-- Download PDF(Quotation and Proforma Invoice) component -->
            <div class="row no-print">
                <DownloadPDF
                    :isAuthenticated="isAuthenticated"
                    :encodedProduct="encodedProduct"
                    :routeCountry="routeCountry"
                    :currency="currency"
                    :product="product"
                    :country="country"
                    :user-language="userLanguage"
                    :countries='countries'
                    :flagPath="flagPath"
                    @country-changed="updateCountry"
                    :routes="routes"
                />
            </div>
            
            <!-- Cryptocurrency Component -->
            <Cryptocurrency
              ref="cryptoComponent"
              :product_usdt="product_usdt"
              :usdtWalletConfig="usdtWalletConfig"
              :qrCodeUrl="qrCodeUrl"
              :usdtUserWallet="usdtUserWallet"
              @update:usdtUserWallet="usdtUserWallet = $event"
              :flashRedMessage="flashRedMessage"
              :flashGreenMessage="flashGreenMessage"
            />
        </div>
    </div>
    <div v-else class="spinner-container">
        <div class="loading-spinner"></div>
    </div>
</template>

<script>
import PaymentMethod from './paymentMethod.vue';
import { toRaw } from 'vue';
import DownloadPDF from './downloadPDF.vue';
import Cryptocurrency from './cryptocurrency.vue';
export default {
    name: 'Main',
    components: {
        PaymentMethod,
        DownloadPDF,
        Cryptocurrency
    },
    data() {
        return {
            user: window.user || null,
            userLanguage: window.userLanguage, // Access global variable
            countries: window.countries, 
            flagPath: window.flagPath,   // From global variable
            isAuthenticated: window.isAuthenticated || false,
            isLoading: false,
            selectedCountry: {},
            routes: window.routes,
            error: null,
            originalProduct: {}, // Store original state
            amendedProduct: {}, // Store amended state
            encodedProduct: window.encodedProduct,
            product: {
                Cat: '',  // Product category
                Id: null, 
                Name: '',  // Product name
                Price: '', // Product price
                Qty: null, // Initial product quantity
                SKU: '',
                Tier: null,
                UnitPrice: '',
                myrPrice: '',
                routeTypes: null,
                tax: '',
                total: ''
                // UnitPrice: null,
            },
            decimal: 2,
            product_usdt: {},
            country: '',
            routeCountry: '',
            topupCount: 0,
            currency: {},
            company: {},
            canPayCreditCard: false,
            initialCanPayCreditCard: false,
            canPayDuitNow: false,
            total_payment: '',
            topupAmount: '',
            alertMessage: '',
            // Maximum allowed topup amount (same as before)
            maxTopupAmount: 4134000,
            translations: {}, // Holds the translations
            locale: window.locale || 'en', // Default to 'en' if locale is not set
            isChangingQty: false, // Tracks if the user is in "Change Quantity" mode
            isChangingAmount: false,
            showTaxInfo: false,
            currentQuantity: 0, // Default slider value, will follow product.Qty
            sliderInstance: null, // Slider instance
            // imagePath: 'images/DuitNowQR-PrimaryLogo.png',
            selectedMethod: null,
            creditCardLinkUrl: '',
            duitnow_b2c_linkUrl: '',
            duitnow_b2b_linkUrl: '',
            // The USDT wallet address from config (set in your global config)
            usdtWalletConfig: window.config.usdtWallet || '',
            usdtUserWallet: window.usdtUserWallet || '', 
            qrCodeUrl: window.config.qrCodeUrl || null,
            flashRedMessage: window.flashRedMessage || '',
            flashGreenMessage: window.flashGreenMessage || ''
        };
    },
    watch: { // Watch for changes in product.total and selectedMethod
        'product.Qty'(newQty){
            console.log("newQty = " + newQty);
            this.$nextTick(() => {
                document.getElementById('product_qty').innerText = number_format(this.product.Qty, 0, '.', ',');
            });
        },
        'product.Price'(newPrice){
            console.log("newPrice = " + newPrice);
            this.$nextTick(() => {
                document.getElementById('product_price').innerText = number_format(this.product.Price, this.decimal, '.', ',');

                const elements = document.getElementsByName('product_price');
                if (elements.length > 0) {
                    elements[0].innerText = number_format(this.product.Price, this.decimal, '.', ',');
                }
            });
        },
        'product.tax'(newTax) {
            console.log("newTax = " + newTax);
            
            if(newTax == null || newTax == 0.00){
                newTax = 0.00.toFixed(2);
                this.product.tax = newTax;
                console.log("newTax = " + this.product.tax);
                
                this.toggleTaxInfo(false);
            }

            this.$nextTick(() => {
                document.getElementById('product_tax').innerText = number_format(this.product.tax, this.decimal, '.', ',');
            });
            // this.$nextTick(() => {
            //     document.getElementById('product_tax').innerText = number_format(this.product.tax, this.decimal, '.', ',');
            // });
            this.toggleTaxInfo(newTax > 0);
        },
        'product.total'(newTotal) {
            console.log("newTotal = " + newTotal);
            // console.log("isAuthenticated = " + this.isAuthenticated);
            if(this.company){
                // console.log("company selfpayment = " + this.company.selfpayment);
            }
            // console.log("topupCount = " + this.topupCount);
            console.log("product Price = " + this.product.Price);
            console.log("currency code = " + this.currency.code);
            this.$nextTick(() => {
                document.getElementById('total_price').innerText = number_format(this.product.total, this.decimal, '.', ',');
            });
            
            /**
             * Sia250210-redefine initialCanPayCreditCard as previous bug (when user select price > 500, it will set the canPaycreditCard to false, but in checkout page, when user lower down the price to less than 500, the canPayCreditCard still false, the credit card payment method will not show to user)
             *  
             * */ 
            if (this.isAuthenticated && this.company != null) {
                if (this.company.selfpayment == 1 && this.topupCount > 1 && this.product.Price < 500  && this.currency.code == 'MYR')
                    this.canPayCreditCard = true;
                    this.initialCanPayCreditCard = this.canPayCreditCard;
            }
            // console.log("watch initialCanPayCreditCard: " , this.initialCanPayCreditCard);
            // Only update if the initial value was true.
            if (this.initialCanPayCreditCard === true) {
                // console.log("canPayCreditCard1: " , this.canPayCreditCard);
                this.canPayCreditCard = newTotal < 500;
            }

            // Dynamically update the credit card link URL
            this.creditCardLinkUrl = `${window.routes.pay360_createPayment
                .replace(':method', 'credit_card')
                .replace(':id', this.encodedProduct.encodedId)}/${newTotal}`;

            this.duitnow_b2c_linkUrl = `${window.routes.pay360_createPayment
            .replace(':method', 'duitnow@b2c')
            .replace(':id', this.encodedProduct.encodedId)}/${newTotal}`;

            this.duitnow_b2b_linkUrl = `${window.routes.pay360_createPayment
            .replace(':method', 'duitnow@b2b')
            .replace(':id', this.encodedProduct.encodedId)}/${newTotal}`;
        },
        
        currentQuantity(newValue) {
            const qtyAlertEl = document.getElementById('qty_alert');
            if (!qtyAlertEl) return;

            if (newValue < 1000) {
                qtyAlertEl.innerText = "Minimum Quantity is 1000";
            } else if (newValue > 50000000) {
                qtyAlertEl.innerText = "Maximum Quantity is 50000000";
            } else {
                qtyAlertEl.innerText = "";
            }
        },
        selectedMethod(newMethod) {
            if (this.isChangingAmount && newMethod && newMethod.id === 2) {
                this.$nextTick(() => {
                    const creditCardLink = document.getElementById('creditcard_link');
                    if (creditCardLink) {
                        creditCardLink.removeAttribute('href');
                        creditCardLink.classList.add('disable');
                        creditCardLink.setAttribute('aria-disabled', 'true');
                    }
                });
            }

            if(this.isChangingAmount && newMethod && newMethod.id === 1) {
                this.$nextTick(() => {
                    const duitnow_b2c_link = document.getElementById('duitnow_b2c_link');
                    if (duitnow_b2c_link) {
                        duitnow_b2c_link.removeAttribute('href');
                        duitnow_b2c_link.classList.add('disable');
                        duitnow_b2c_link.setAttribute('aria-disabled', 'true');
                    }
                    const duitnow_b2b_link = document.getElementById('duitnow_b2b_link');
                    if (duitnow_b2b_link) {
                        duitnow_b2b_link.removeAttribute('href');
                        duitnow_b2b_link.classList.add('disable');
                        duitnow_b2b_link.setAttribute('aria-disabled', 'true');
                    }
                });
            }
        }
    },
    mounted() {
        // console.log('countries: ' , countries);
        this.loadTranslations();
        this.fetchCheckoutData();
        console.log('products: ' , this.product);
        console.log("mounted canPayCreditCard: " , this.canPayCreditCard);
        // Store the initial value of canPayCreditCard
        this.initialCanPayCreditCard = this.canPayCreditCard;
        console.log("initialCanPayCreditCard: " , this.initialCanPayCreditCard);
        // Set canPayCreditCard initially based on the product total
        if (this.initialCanPayCreditCard === true) {
            this.canPayCreditCard = this.product.total <= 500;
        }
        // console.log("canPayCreditCard1: " , this.canPayCreditCard);
        // Initialize the credit card link URL
        this.creditCardLinkUrl = `${window.routes.pay360_createPayment
            .replace(':method', 'credit_card')
            .replace(':id', this.encodedProduct.encodedId)}/${this.product.total}`;
        // DuitNow B2C Link
        this.duitnow_b2c_linkUrl = `${window.routes.pay360_createPayment
            .replace(':method', 'duitnow@b2c')
            .replace(':id', this.encodedProduct.encodedId)}/${this.product.total}`;
        // DuitNow B2B Link
        this.duitnow_b2b_linkUrl = `${window.routes.pay360_createPayment
            .replace(':method', 'duitnow@b2b')
            .replace(':id', this.encodedProduct.encodedId)}/${this.product.total}`;

        //nextTick means take action immediately when found
        this.$nextTick(() => {
            const elements = document.getElementsByName('product_price');
            if (elements.length > 0) {
                elements[0].innerText = number_format(this.product.Price, this.decimal, '.', ',');
            }
            document.getElementById('product_qty').innerText = number_format(this.product.Qty, 0, '.', ',');
            document.getElementById('product_price').innerText = number_format(this.product.Price, this.decimal, '.', ',');
            document.getElementById('product_tax').innerText = number_format(this.product.tax, this.decimal, '.', ',');
            document.getElementById('total_price').innerText = number_format(this.product.total, this.decimal, '.', ',');

            const preloadTotalPayment = this.total_payment;
            
            console.log("preloadTotalPayment", preloadTotalPayment);
            // Only run checkTotalPayment if total_payment is present (or meets a condition)
            if (this.total_payment) {
                // console.log("preloadTotalPayment", this.total_payment);
                this.checkTotalPayment();
            }
        });
    },
    computed: {
        formattedUnitPrice() {
            const unitPrice = parseFloat(this.product.UnitPrice);
            if (!isNaN(unitPrice)) {
                return unitPrice.toFixed(4); // Format to 4 decimal places
            }
            return '0.0000'; // Default when UnitPrice is invalid
        },
        paymentMethods() {
            const methods = [
                {
                    id: 1,
                    name: this.translate('Online Banking/Wallets'),
                    icon: 'fa fa-send',
                    details: `
                        <div style="padding:0px 0px;margin-top:10px">
                            
                            <label for="retailbanking">
                                <a id="duitnow_b2c_link" name="duitnow_b2c_link" 
                                    href="${window.routes.pay360_createPayment
                                        .replace(':method', 'duitnow@b2c')
                                        .replace(':id', this.encodedProduct.encodedId)}/${this.product.total}" 
                                    style="font-weight:500;">
                                    ${this.translate('Online Retail Banking')}
                                </a>
                            </label><br>
                            
                            <label for="corporatebanking">
                                <a id="duitnow_b2b_link" name="duitnow_b2b_link" 
                                    href="${window.routes.pay360_createPayment
                                        .replace(':method', 'duitnow@b2b')
                                        .replace(':id', this.encodedProduct.encodedId)}/${this.product.total}" 
                                    style="font-weight:500;">
                                    ${this.translate('Online Corporate Banking')}
                                </a>
                            </label>
                        </div>
                        `,
                    image: window.cdnUrl + 'images/DuitNowQR-PrimaryLogo.png',
                },
                {
                    id: 2,
                    name: this.translate('Credit Card'),
                    icon: 'fa fa-credit-card',
                    details: `
                        <div style="margin-left:20px">
                            <a class="glyphicon glyphicon-credit-card " 
                                style="font-size:50px;" 
                                id="creditcard_link" 
                                name="creditcard_link" 
                                href="${window.routes.pay360_createPayment
                                    .replace(':method', 'credit_card')
                                    .replace(':id', this.encodedProduct.encodedId)}/${this.product.total}" >
                            </a><br />
                            <span class="glyphicon-class">${this.translate('Credit Card')}</span>
                        </div>
                    `,
                    image: null,
                },
                {
                    id: 3,
                    name: this.translate('Bank Transfer'),
                    icon: 'fa fa-bank',
                    image: null,
                },
                {
                    id: 4,
                    name: this.translate('Cryptocurrency'),
                    icon: 'fa fa-bitcoin',
                    details: this.translate('USDT TRC20'),
                    image: window.cdnUrl + 'images/Tether_USDT.png',
                    // Add custom handler property
                    handler: () => this.$refs.cryptoComponent.usdtBtnClicked()
                },
            ];

            // Filter out methods based on `canPayCreditCard` and `canPayDuitNow`
            // return methods.filter(method => 
            //     !(method.id === 2 && !this.canPayCreditCard) && // Exclude credit card if not allowed
            //     !(method.id === 1 && !this.canPayDuitNow)      // Exclude DuitNow if not allowed
            //     // !(method.id === 2 && !this.canPayDuitNow)   // Exclude Credit Card if DuitNow is not allowed
            // );
            // Debug each method along with the current values of the booleans
            const filtered = methods.filter(method => {
            // console.log('Checking method', method.id, {
            //     canPayCreditCard: this.canPayCreditCard,
            //     canPayDuitNow: this.canPayDuitNow
            // });
            // If it's Credit Card (id:2) and credit card payment is not allowed, exclude it.
            if (method.id === 2 && !this.canPayCreditCard) {
                return false;
            }
            // If it's DuitNow/Online Banking (id:1) and DuitNow is not allowed, exclude it.
            if (method.id === 1 && !this.canPayDuitNow) {
                return false;
            }
            return true;
            });

            // console.log("Filtered payment methods:", filtered);
            return filtered;
        },
        testOurServiceMessage() {
            return `${this.translate('<span class=\"cred text-bold\">PLEASE ENSURE TO TEST OUR SERVICES</span> before starting any business with us')} `;
        },
        newCustomerMessage(){
            return `${this.translate('For New Customers, <span class=\"cred text-bold\">PLEASE CONTACT US BEFORE MAKING YOUR FIRST PAYMENT</span>')} `;
        },
        refundMessage(){
            return `${this.translate('We <span class=\"cred text-bold\">DO NOT OFFER ANY REFUND OF MONEY</span> at any stage or at any condition once the transaction has been done')} `;
        }
    },
    methods: {
        checkTotalPayment() { //When user click back button from stripe, we auto adjust back to the same topup amount they chosen previously
            const preloadTotalPayment = parseFloat(this.total_payment);
            // If totalSellingPriceArr is an object, get its values
            // const priceValues = Object.values(this.totalSellingPriceArr);
            const priceValues = Object.values(this.totalSellingPriceArr).map(val => parseFloat(val));
            // console.log("priceValues", priceValues);
            // Check if preloadTotalPayment is NOT in priceValues
            if (!priceValues.includes(preloadTotalPayment)) {
                this.topupAmount = preloadTotalPayment;
                let topupAmount = parseFloat(this.topupAmount);
                
                this.product.total = topupAmount.toFixed(2);
                console.log("product total = " + this.product.total);

                // Tax and total calculation
                 // for login user, will use companyCountry, for non-login user and not yet fill in the form, will use route country(also use this.country, set in paymentGatewayController)
                console.log("company/routeCountry = " + this.country);
                if (this.country === 'MYS') {
                    this.product.Price = (this.product.total / 1.06).toFixed(2);
                    this.product.tax = (parseFloat(this.product.total) - parseFloat(this.product.Price)).toFixed(2);
                } else {
                    this.product.Price = this.product.total;
                    this.product.tax = '-';
                }

                console.log(`product Price: ${this.product.Price}`);
                console.log(`product Tax: ${this.product.tax}`);
                console.log(`product Total: ${this.product.total}`);

                // console.log("totalSellingPriceArr = ", this.totalSellingPriceArr);
                var entries = Object.entries(this.totalSellingPriceArr).map(([key, value]) => [parseInt(key), parseFloat(value)]); // Convert the entries of totalSellingPriceArr to an array of [key, value] pairs
                    entries.sort((a, b) => a[1] - b[1]); // Sort the keys in ascending order
                    var nearestTotalQuantityKey = null;
                    for (var i = 0; i < entries.length; i++) {
                        var [key, value] = entries[i];
                        if (value <= this.product.total) {
                            nearestTotalQuantityKey = key;
                        } else {
                            break;
                        }
                    }

                var nearestRouteRateVal = this.checkoutRouteRateArr[nearestTotalQuantityKey];
                console.log("nearestRouteRateVal: " + nearestRouteRateVal);

                this.product.UnitPrice = nearestRouteRateVal;
                this.product.Qty = Math.round(parseFloat(this.product.Price) / parseFloat(this.product.UnitPrice));
                if (this.country != 'MYS' || this.currency.code != 'MYR') {
                    this.product.myrPrice = roundToTwo(parseFloat(this.myrRates[nearestTotalQuantityKey]) * parseFloat(this.product.Qty)).toFixed(2);
                } else {
                    this.product.myrPrice = this.product.Price;
                }
                
                console.log("Product:", toRaw(this.product));
                console.log("Route Country: " + this.routeCountry);
                console.log("Currency: " + this.currency.code);

                var encodedRouteCountry = btoa(this.routeCountry); // Sia240923 - method to encode string in javascript
                var encodedCurrency = btoa(this.currency.code);
                console.log("EncodedRouteCountry: " + encodedRouteCountry);
                console.log("EncodedCurrency: " + encodedCurrency);

                // Update SKU if applicable
                var namePrefix = this.product.Name.split('-');
                this.product.Name = namePrefix[0]  + '- Custom';
                var SKUarr = this.product.SKU.split('_');
                if (this.product.Cat === 'WhatsApp Template Msg') {
                    this.product.SKU = `${SKUarr[0]}_CUSTOM`;
                } else {
                    this.product.SKU = `${SKUarr[0]}_${SKUarr[1]}_CUSTOM`;
                }
                console.log(`Updated SKU: ${this.product.SKU}`);
            } 
        },
        fetchCheckoutData() {
            // Load the checkoutData from the global window object
            if (window.checkoutData) {
                // console.log("window.checkoutData = ");
                // console.log(window.checkoutData);
                this.product = window.checkoutData.product;
                this.product_usdt = window.checkoutData.product_usdt;
                this.country = window.checkoutData.country;
                this.topupCount = window.checkoutData.topupCount;
                this.currency = window.checkoutData.currency;
                this.canPayCreditCard = window.checkoutData.canPayCreditCard;
                this.canPayDuitNow = window.checkoutData.canPayDuitNow;
                this.total_payment = window.checkoutData.total_payment;
                this.checkoutRouteRateArr = window.checkoutData.checkoutRouteRateArr;
                this.totalSellingPriceArr = window.checkoutData.totalSellingPriceArr;
                this.myrRates = window.checkoutData.myrRates;
                this.routeCountry = window.checkoutData.routeCountry;
                this.company = window.checkoutData.company;
                // console.log('main.vue canPayDuitNow', this.canPayDuitNow);
            } else {
                this.error = 'Failed to load checkout data.';
            }
        },
        getDownloadQuotationLink() {
            var encodedId = this.encodedProduct.encodedId
            var encodedRouteCountry = btoa(this.routeCountry); // Sia240923 - method to encode string in javascript
            var encodedCurrency = btoa(this.currency.code);
            // var totalAmount = this.product.total;
            var amount = this.product.Price;
            var companyCountry = this.country;
            if (companyCountry == 'MYS'){
                return `/download_quotation/${encodedId}/${amount}/${encodedRouteCountry}/${encodedCurrency}`;
            }else{
                return `/download_quotation/${encodedId}/${amount}/${encodedRouteCountry}/${encodedCurrency}`;
            }
        },
        getDownloadProformaInvoiceLink() {
            var encodedId = this.encodedProduct.encodedId
            var encodedRouteCountry = btoa(this.routeCountry); // Sia240923 - method to encode string in javascript
            var encodedCurrency = btoa(this.currency.code);
            var amount = this.product.Price;
            var companyCountry = this.country;
            if (companyCountry == 'MYS'){
                return `/proforma_invoice/${encodedId}/${amount}/${encodedRouteCountry}/${encodedCurrency}`;
            }else{
                return `/proforma_invoice/${encodedId}/${amount}/${encodedRouteCountry}/${encodedCurrency}`;
            }
        },
        async loadTranslations() {
            if (this.locale !== 'en') {
                try {
                    this.isLoading = true; // Set loading state to true
                    
                    // $('#spinner_gif_modal').modal('show');
                    console.log(`Fetching translations for locale: ${this.locale}`);
                    // Access translations from the global variable injected into the page
                    const allTranslations = window.allTranslations || [];

                    // Filter translations for the current locale and convert to { key: value } format
                    const localeTranslations = allTranslations
                        .filter(t => t.locale === this.locale)
                        .reduce((acc, curr) => {
                            acc[curr.text] = curr.value; // Use 'text' as key and 'value' as translation
                            return acc;
                        }, {});

                    // console.log('Loaded translations:', localeTranslations);
                    this.translations = localeTranslations;
                } catch (error) {
                    console.error('Error fetching translations:', error.message);
                }finally {
                    this.isLoading = false; // Set loading state to true
                    $('#spinner_gif_modal').modal('hide');
                }
            } else {
                console.log('Locale is "en"; no translations needed.');
            }
        },
        translate(key) {
            // If the locale is 'en', return the key directly
            if (this.locale === 'en') {
                return key;
            }
            // $('#spinner_gif_modal').modal();
            // $('#spinner_gif_modal').modal('hide');
            // Otherwise, return the translation if available
            return this.translations[key] || key;
        },
        getCurrentDate() {
            const date = new Date();
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        },
        handleMethodSelected(method) {
            this.selectedMethod = method; // Update the selected method in main.vue
        },
        enableCreditCardLink() {
            this.$nextTick(() => {
                const creditCardLink = document.getElementById('creditcard_link');
                if (creditCardLink) {
                    creditCardLink.setAttribute('href', this.creditCardLinkUrl);
                    creditCardLink.classList.remove('disable');
                    creditCardLink.removeAttribute('aria-disabled');
                }
            });
        },
        enableDuitNowLink() {
            this.$nextTick(() => {
                const duitnow_b2c_link = document.getElementById('duitnow_b2c_link');
                if (duitnow_b2c_link) {
                    duitnow_b2c_link.setAttribute('href', this.duitnow_b2c_linkUrl);
                    duitnow_b2c_link.classList.remove('disable');
                    duitnow_b2c_link.removeAttribute('aria-disabled');
                }
                const duitnow_b2b_link = document.getElementById('duitnow_b2b_link');
                if (duitnow_b2b_link) {
                    duitnow_b2b_link.setAttribute('href', this.duitnow_b2b_linkUrl);
                    duitnow_b2b_link.classList.remove('disable');
                    duitnow_b2b_link.removeAttribute('aria-disabled');
                }
            });
            
        },
        toggleTaxInfo(show) {
            this.showTaxInfo = show;
        },
        updateCountry(country) { // for non-login user, will get the country from the form
            this.selectedCountry = country; // Update parent's state
            console.log("selectedCountry = " , country.alpha3);
            // Sia241111-total amount passed to URL no need to calculate SST first, will be calculated later in PaymentGatewayController
            console.log("total amount before click quotation/proforma invoice: " + this.product.Price);
            if(this.selectedCountry.alpha3 === 'MYS'){
                this.product.total = (this.product.Price * 1.06).toFixed(2);
                this.product.tax = (this.product.total - this.product.Price).toFixed(2);
                console.log("total amount after click quotation/proforma invoice: " + this.product.total);
            }else{
                this.product.total = this.product.Price;
                this.product.tax = '-';
                console.log("total amount after click quotation/proforma invoice: " + this.product.total);
            }
        },
        //#region updateProductFromChangingTotal
        toggleChangeAmount() {
            if (this.isChangingQty) {
                this.cancelChangeQty(); // Automatically cancel Change Quantity mode
            }
            this.alertMessage = '';
            this.isChangingAmount = !this.isChangingAmount; // Toggle the change amount mode
            // this.canPayCreditCard = false;
            // Debugging: Check if the method is called
            console.log('toggleChangeAmount called');
            // console.log('selected method: ', this.selectedMethod)

            // Save original product state
            this.originalProduct = {
                SKU: this.product.SKU,
                Qty: this.product.Qty,
                Price: this.product.Price,
                UnitPrice: this.product.UnitPrice,
                tax: this.product.tax,
                total: this.product.total,
            };
            // console.log("originalProduct = " , this.originalProduct);

            // immediate update
            this.$nextTick(() => {
                if (this.isChangingAmount) {
                    // Set the input value to product.total
                    this.topupAmount = this.product.total;

                    // Disable credit card link
                    const creditCardLink = document.getElementById('creditcard_link');
                    if (creditCardLink) {
                        creditCardLink.removeAttribute('href');
                        creditCardLink.classList.add('disable');
                        creditCardLink.setAttribute('aria-disabled', 'true');
                    }

                    // Disable DuitNow B2C and B2B links
                    const duitnow_b2c_link = document.getElementById('duitnow_b2c_link');
                    if (duitnow_b2c_link) {
                        duitnow_b2c_link.removeAttribute('href');
                        duitnow_b2c_link.classList.add('disable');
                        duitnow_b2c_link.setAttribute('aria-disabled', 'true');
                    }
                    const duitnow_b2b_link = document.getElementById('duitnow_b2b_link');
                    if (duitnow_b2b_link) {
                        duitnow_b2b_link.removeAttribute('href');
                        duitnow_b2b_link.classList.add('disable');
                        duitnow_b2b_link.setAttribute('aria-disabled', 'true');
                    }
                }
            });
        },
        handleInput() {
            // Convert the current value to a string (in case it's a number)
            let value = this.topupAmount.toString();

            // Enforce two decimal places for any value.
            if (value.includes('.')) {
                let parts = value.split('.');
                if (parts[1].length > 2) {
                // Truncate any extra decimals beyond two digits.
                this.topupAmount = parts[0] + '.' + parts[1].slice(0, 2);
                return;
                }
            }

            let topupAmount = parseFloat(value);

            // Check if the input is a valid number first
            if (!isNaN(topupAmount)) {
                // If the value equals the max but isn't in the correct formatted state,
                // reset it to the formatted value (prevents extra zeros or digits)
                const formattedMax = this.maxTopupAmount.toFixed(2);

                // 1. Check for maximum value
                if (topupAmount > this.maxTopupAmount) {
                this.alertMessage = `${this.translate('Maximum topup amount is')} ${this.currency.code} ${this.maxTopupAmount}`;
                // Set the input to the maximum allowed amount (with 2 decimals)
                this.topupAmount = formattedMax;
                return; // Exit early to prevent further checks
                }

                // 2. Limit the total length to 10 characters
                if (value.length > 10) {
                this.topupAmount = value.slice(0, 10);
                return;
                }

                // If all checks pass, clear the alert
                this.alertMessage = '';
            } else {
                // If the value is not a number (e.g. empty), you might want to clear the error.
                this.alertMessage = '';
            }
        },
        updateProductFromChangingTotal() {
            let topupAmount = parseFloat(this.topupAmount);
            // Check that the value is a valid number
            if (isNaN(topupAmount)) {
                this.alertMessage = this.translate(`Please enter a valid amount.`);
                return;
            }
            let productLowestAmount;
            // Ensure product.total is a number
            if(!this.selectedCountry.alpha3){
                var productAmountLowest = Object.values(this.totalSellingPriceArr)[0];
                productLowestAmount = parseFloat(productAmountLowest);
            }else{
                if(this.selectedCountry.alpha3 === 'MYS'){
                    var productAmountLowest = Object.values(this.totalSellingPriceArr)[0];
                    productLowestAmount = parseFloat(productAmountLowest);
                    console.log("productLowestAmount = " + productLowestAmount);
                }else{
                    var productAmountLowest = Object.values(this.totalSellingPriceArr)[0];
                    productLowestAmount = parseFloat(productAmountLowest / 1.06);
                    console.log("productLowestAmount = " + productLowestAmount);
                }
            }
            

            if (topupAmount < productLowestAmount) {
                const code = this.currency.code;
                const amount = productLowestAmount.toFixed(2);
                // document.getElementById('topupAmount_alert').innerHTML = "Minimum topup amount is " + code + " " + amount;
                this.alertMessage = `${this.translate('Minimum topup amount is')} ${code} ${amount}`;
                return;
            }

            // Clear any existing error message and proceed with the update logic
            this.alertMessage = '';

            $('#spinner_gif_modal').modal();
            var amendedProduct = this.product;
            this.product.total = topupAmount.toFixed(2);
            console.log("product total = " + this.product.total);

            // Tax and total calculation
            const formCountrySelected = this.selectedCountry.alpha3; //TODO: remove this after implement the country selection
            console.log("formCountrySelected = " + formCountrySelected);
            if (formCountrySelected) { // for non-login user, will get the country from the form
                if (formCountrySelected === 'MYS') {
                    console.log("is MYS");
                    this.product.Price = (this.product.total / 1.06).toFixed(2);
                    this.product.tax = (parseFloat(this.product.total) - parseFloat(this.product.Price)).toFixed(2);
                } else {
                    console.log("Not MYS");
                    this.product.Price = this.product.total;
                    this.product.tax = '-';
                }
            } else { // for login user, will use companyCountry
                console.log("companyCountry = " + this.country);
                if (this.country === 'MYS') {
                    this.product.Price = (this.product.total / 1.06).toFixed(2);
                    this.product.tax = (parseFloat(this.product.total) - parseFloat(this.product.Price)).toFixed(2);
                } else {
                    this.product.Price = this.product.total;
                    this.product.tax = '-';
                }
            }

            // if (this.currency.code !== 'MYR') {
            //     this.product.myrPrice = (this.myrRates[nearestRouteRateKey] * this.currentQuantity).toFixed(2);
            // }
            console.log(`product Price: ${this.product.Price}`);
            console.log(`product Tax: ${this.product.tax}`);
            console.log(`product Total: ${this.product.total}`);

            // console.log("totalSellingPriceArr = ", this.totalSellingPriceArr);
            var entries = Object.entries(this.totalSellingPriceArr).map(([key, value]) => [parseInt(key), parseFloat(value)]); // Convert the entries of totalSellingPriceArr to an array of [key, value] pairs
                entries.sort((a, b) => a[1] - b[1]); // Sort the keys in ascending order
                var nearestTotalQuantityKey = null;
                for (var i = 0; i < entries.length; i++) {
                    var [key, value] = entries[i];
                    if (value <= this.product.total) {
                        nearestTotalQuantityKey = key;
                    } else {
                        break;
                    }
                }

            var nearestRouteRateVal = this.checkoutRouteRateArr[nearestTotalQuantityKey];
            console.log("nearestRouteRateVal: " + nearestRouteRateVal);

            this.product.UnitPrice = nearestRouteRateVal;
            this.product.Qty = Math.round(parseFloat(this.product.Price) / parseFloat(this.product.UnitPrice));
            if (this.country != 'MYS' || this.currency.code != 'MYR') {
                this.product.myrPrice = roundToTwo(parseFloat(this.myrRates[nearestTotalQuantityKey]) * parseFloat(this.product.Qty)).toFixed(2);
            } else {
                this.product.myrPrice = this.product.Price;
            }

            console.log("Product:", toRaw(this.product));
            console.log("Route Country: " + this.routeCountry);
            console.log("Currency: " + this.currency.code);

            var encodedRouteCountry = btoa(this.routeCountry); // Sia240923 - method to encode string in javascript
            var encodedCurrency = btoa(this.currency.code);
            console.log("EncodedRouteCountry: " + encodedRouteCountry);
            console.log("EncodedCurrency: " + encodedCurrency);

            // Update SKU if applicable
            var namePrefix = this.product.Name.split('-');
            this.product.Name = namePrefix[0]  + '- Custom';
            var SKUarr = this.product.SKU.split('_');
            if (this.product.Cat === 'WhatsApp Template Msg') {
                this.product.SKU = `${SKUarr[0]}_CUSTOM`;
            } else {
                this.product.SKU = `${SKUarr[0]}_${SKUarr[1]}_CUSTOM`;
            }
            console.log(`Updated SKU: ${this.product.SKU}`);
            $('#spinner_gif_modal').modal('hide');

            this.isChangingAmount = false; // Exit change amount mode
            this.enableCreditCardLink(); // Re-enable the credit card link
            this.enableDuitNowLink(); // Re-enable the DuitNow B2C and B2B links
        },
        cancelChangeAmount() {
            // Revert product to original state
            this.product.SKU = this.originalProduct.SKU; // Revert SKU back to original state
            this.product.Qty = this.originalProduct.Qty;
            this.product.Price = this.originalProduct.Price;
            this.product.UnitPrice = this.originalProduct.UnitPrice;
            this.product.tax = this.originalProduct.tax;
            this.product.total = this.originalProduct.total;

            this.isChangingAmount = false; // Exit change amount mode
            this.enableCreditCardLink(); // Re-enable the credit card link
            this.enableDuitNowLink(); // Re-enable the DuitNow B2C and B2B links
        },
        //#endregion
        //#region updateProductFromChangingQuantity
        toggleChangeQty() {
            if (this.isChangingAmount) {
                this.cancelChangeAmount(); // Automatically cancel Change Amount mode
            }
            this.isChangingQty = !this.isChangingQty; // Toggle Change Quantity mode
            // Save original product state
            this.originalProduct = {
                Name: this.product.Name,
                SKU: this.product.SKU,
                Qty: this.product.Qty,
                Price: this.product.Price,
                UnitPrice: this.product.UnitPrice,
                tax: this.product.tax,
                total: this.product.total,
            };
            // Update SKU if applicable
            var namePrefix = this.product.Name.split('-');
            this.product.Name = namePrefix[0]  + '- Custom';
            const SKUarr = this.product.SKU.split('_');
            if (this.product.Cat === 'WhatsApp Template Msg') {
                this.product.SKU = `${SKUarr[0]}_CUSTOM`;
            } else {
                this.product.SKU = `${SKUarr[0]}_${SKUarr[1]}_CUSTOM`;
            }
            console.log(`Updated SKU: ${this.product.SKU}`);


            this.currentQuantity = this.product.Qty; // Set slider default to product.Qty
            this.isChangingQty = true;

            this.$nextTick(() => {
                this.initializeSlider();
            });
        },
        cancelChangeQty() {
            // Revert product to original state
            this.product.Name = this.originalProduct.Name; // Revert SKU back to original/previous state
            this.product.SKU = this.originalProduct.SKU; 
            this.product.Qty = this.originalProduct.Qty;
            this.product.Price = this.originalProduct.Price;
            this.product.UnitPrice = this.originalProduct.UnitPrice;
            this.product.tax = this.originalProduct.tax;
            this.product.total = this.originalProduct.total;

            // Exit change quantity mode
            this.isChangingQty = false;

            // Clear slider and UI changes
            this.$forceUpdate();// Revert to the original quantity
        },
        updateProductFromChangingQty() {
            // Finalize the currentQuantity
            if (this.currentQuantity < 1000) {
                document.getElementById('qty_alert').innerText = "Quantity must be greater than 1000.";
                return;
            }

            // Sync and finalize data
            this.product.Qty = this.currentQuantity;
            // document.getElementById('product_qty').innerText = number_format(this.product.Qty, 0, '.', ',');
            // this.product.Qty = number_format(this.product.Qty, 0, '.', ',');
            // console.log("quantity: " + this.product.Qty);

            // Clear the temporary original state
            this.originalProduct = {};

            // Exit change quantity mode
            this.isChangingQty = false;

            // Clear error message
            document.getElementById('qty_alert').innerText = '';
        },
        initializeSlider() {
            const sliderElement = document.getElementById('qtySlider');

            if (!sliderElement) {
                console.warn("Slider element not found. Ensure the DOM is properly loaded.");
                return;
            }

            // Destroy any existing slider instance to avoid conflicts
            if (this.sliderInstance) {
                this.sliderInstance.destroy();
                this.sliderInstance = null;
            }

            // Initialize the slider using the constructor
            this.sliderInstance = new Slider(sliderElement, {
                min: 0,
                max: 500000,
                step: 1000,
                value: this.currentQuantity,
                tooltip: 'show',
            });

            // Attach the instance to the DOM element for global access
            sliderElement.sliderInstance = this.sliderInstance;

            // Bind the slider's event
            this.sliderInstance.on('slide', (value) => {
                this.updateSlider(value);
            });

            console.log("slider", $('input.slider').length);
            console.log('Slider value:', this.sliderInstance.getValue());
            console.log("Slider initialized successfully.");
        },
        updateSlider(value) {
            const numericValue = parseInt(value) || 0;
            const minQty = 1000;
            const maxQty = 50000000;
            const qtyAlertEl = document.getElementById('qty_alert');

            // If the input value exceeds the maximum limit, display error and do nothing else
            if (numericValue > maxQty) {
                if (qtyAlertEl) {
                    qtyAlertEl.innerText = `Maximum Quantity is ${maxQty}`;
                }
                return;
            }

            // If the input value is below the minimum limit, display error and do nothing else
            if (numericValue < minQty) {
                if (qtyAlertEl) {
                    qtyAlertEl.innerText = `Minimum Quantity is ${minQty}`;
                }
                return;
            }

            // Clear any previous error messages
            if (qtyAlertEl) {
                qtyAlertEl.innerText = '';
            }

            if (this.currentQuantity !== numericValue) {
                this.currentQuantity = numericValue;

                // Convert the keys of checkoutRouteRateArr to numbers and sort them in ascending order.
                const keys = Object.keys(this.checkoutRouteRateArr)
                    .map(Number)
                    .sort((a, b) => a - b);

                // Default to the smallest key as the nearest key initially.
                let nearestKey = keys[0]; // Default to the smallest key

                // Iterate over the sorted keys to find the largest key that is <= quantity.
                for (let i = 0; i < keys.length; i++) {
                    if (keys[i] <= this.currentQuantity) {
                        nearestKey = keys[i]; // Update nearest key if current key fits the criteria.
                    } else {
                        break; // Stop checking once a key exceeds the quantity.
                    }
                }

                // Update product data dynamically
                const nearestRouteRateKey = nearestKey;
                const nearestRouteRateVal = this.checkoutRouteRateArr[nearestKey];
                // const { key: nearestRouteRateKey, value: nearestRouteRateVal } = this.getNearestRouteRate(this.currentQuantity);
                this.product.UnitPrice = nearestRouteRateVal;
                this.product.Price = (this.currentQuantity * nearestRouteRateVal).toFixed(2);

                // Tax and total calculation
                const formCountrySelected = this.selectedCountry.alpha3; // for non-login user after select country
                console.log("formCountrySelected = " + formCountrySelected);
                if (formCountrySelected) { // for non-login user, will get the country from the form
                    if (formCountrySelected === 'MYS') {
                        console.log("is MYS");
                        this.product.tax = (this.product.Price * 0.06).toFixed(2);
                        this.product.total = (parseFloat(this.product.Price) + parseFloat(this.product.tax)).toFixed(2);
                    } else {
                        console.log("Not MYS");
                        this.product.tax = '-';
                        this.product.total = this.product.Price;
                    }
                } else { // for login user and non-login user that haven't fill in the form, will use company/routeCountry(already set in paymentgatewayController > checkout)
                    console.log("company/routeCountry = " + this.country);
                    if (this.country === 'MYS') {
                        console.log("is MYS");
                        this.product.tax = (this.product.Price * 0.06).toFixed(2);
                        this.product.total = (parseFloat(this.product.Price) + parseFloat(this.product.tax)).toFixed(2);
                    } else {
                        console.log("Not MYS");
                        this.product.tax = '-';
                        this.product.total = this.product.Price;
                    }
                }

                if (this.currency.code !== 'MYR') {
                    this.product.myrPrice = (this.myrRates[nearestRouteRateKey] * this.currentQuantity).toFixed(2);
                }
                console.log(`Updated Product Price: ${this.product.Price}`);
                console.log(`Updated Product Tax: ${this.product.tax}`);
                console.log(`Updated Product Total: ${this.product.total}`);
                // Sync changes with UI
                this.$forceUpdate();
            }
        },
        //#endregion
        selectMethod(method) { //select payment method
            console.log('Selected Method:', method.id);
            const timelineItems = document.querySelectorAll('.timeline li');
            let previousMethodId = this.selectedMethod ? this.selectedMethod.id : null;

            // Update selected method
            this.selectedMethod = method;

            timelineItems.forEach(item => {
                const methodId = parseInt(item.getAttribute('data-method-id'), 10);

                if (methodId === method.id) {
                    // Expand the newly selected method
                    item.classList.add('active');
                } else if (methodId === previousMethodId) {
                    // Collapse the previously selected method
                    item.classList.remove('active');
                }
            });
        },
    },
    beforeDestroy() {
        if (this.sliderInstance) {
            this.sliderInstance.destroy();
            this.sliderInstance = null;
        }
    }
};

function roundToTwo(num) {
    return Math.round(num * 100) / 100;
}
</script>

<style>
a.disable {
    pointer-events: none;
    cursor: not-allowed;
    color: grey;
}
/* Container to center the spinner */
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Full height of the viewport */
}

/* Spinner styling */
.loading-spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(0, 0, 0, 0.1);
  border-top-color: #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Optional: Add smooth rounded corners */
.changing-qty {
    /* border: 1px solid #ccc; */
    border-radius: 3px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}
</style>